import { render, staticRenderFns } from "./Acciones.vue?vue&type=template&id=66e6654a&scoped=true"
import script from "./Acciones.vue?vue&type=script&lang=js"
export * from "./Acciones.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e6654a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66e6654a')) {
      api.createRecord('66e6654a', component.options)
    } else {
      api.reload('66e6654a', component.options)
    }
    module.hot.accept("./Acciones.vue?vue&type=template&id=66e6654a&scoped=true", function () {
      api.rerender('66e6654a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/otro-documento/Acciones.vue"
export default component.exports